/* report.icon.svg.js */

module.exports = {
    icon: `<svg viewBox="0 0 30 30" preserveAspectRatio="none">
           <g>
               <path class="foreground-gl" d="M3.9,30L3.9,30C1.8,30,0,28.1,0,25.9v-7.5h7.7v7.5C7.7,28.1,6,30,3.9,30z"/>                <path class="foreground-gl" d="M15.1,30L15.1,30c-2.1,0-3.9-1.9-3.9-4.1V9.2h7.7v16.7C18.9,28.1,17.2,30,15.1,30z"/>
               <path class="foreground-gl" d="M26.1,30L26.1,30c-2.1,0-3.9-1.9-3.9-4.1V0H30v25.9C30,28.1,28.2,30,26.1,30z"/>
           </g>
          </svg>`
};
